import { type UseQueryResult, useQuery } from 'react-query';
import { RecurrenceTypeService } from '../../services/wealthlane-job-scheduler-services';

const useGetRecurrenceTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const recurrenceTypesOptions = useQuery(
    ['getRecurrenceTypes'],
    async () => {
      return await handleRequest(
        RecurrenceTypeService.getApiSchedulerApiAppRecurrenceTypeRecurrenceTypes()
      );
    },
    {
      select: (data) => {
        if (!data) return undefined;

        const options = data.map((item) => ({
          label: item.displayName ?? '',
          value: item.id ?? '',
        }));

        const customIndex = options.findIndex((item) => item.label.toLowerCase() === 'custom');

        if (customIndex !== -1) {
          const customOption = options.splice(customIndex, 1)[0];
          options.push(customOption);
        }

        return options;
      },
    }
  );

  return recurrenceTypesOptions;
};

export default useGetRecurrenceTypes;
